module.exports = __webpack_public_path__ + "static/media/comments-dollar.2952222f.svg";